import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from '../layout/pagination/pagination.module';
import { CreateComponent } from './modals/create/create.component';
import { DeleteComponent } from './modals/delete/delete.component';
import { EditComponent } from './modals/edit/edit.component';
import { UpsellComponent } from './upsell.component';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    UpsellComponent,
    DeleteComponent,
    CreateComponent,
    EditComponent,
  ],
  exports: [UpsellComponent],
})
export class UpsellModule {}
